// apps/web/src/api/packaging-options.ts — typed wrappers around
// `/api/packaging-options/*` (#995 backend, #1152 admin surface).
// Mirrors the arrival-cities CRUD contract.

import {
  GetPackagingOptionsResponseSchema,
  PackagingOptionSchema,
  type CreatePackagingOptionInput,
  type GetPackagingOptionsQuery,
  type GetPackagingOptionsResponse,
  type PackagingOption,
  type PatchPackagingOptionInput,
} from '@magimp/shared';
import { request } from './client.js';

function withQuery(path: string, qs: string): string {
  return qs.length > 0 ? `${path}?${qs}` : path;
}

export function listPackagingOptions(
  query: Partial<GetPackagingOptionsQuery> = {},
): Promise<GetPackagingOptionsResponse> {
  const params = new URLSearchParams();
  if (query.q) params.set('q', query.q);
  if (query.active !== undefined) params.set('active', String(query.active));
  if (query.cursor) params.set('cursor', query.cursor);
  if (query.limit !== undefined) params.set('limit', String(query.limit));
  return request<GetPackagingOptionsResponse>(
    withQuery('/packaging-options', params.toString()),
    { method: 'GET' },
    {},
    GetPackagingOptionsResponseSchema,
  );
}

export function fetchPackagingOption(id: string): Promise<PackagingOption> {
  return request<PackagingOption>(
    `/packaging-options/${encodeURIComponent(id)}`,
    { method: 'GET' },
    {},
    PackagingOptionSchema,
  );
}

export function createPackagingOption(body: CreatePackagingOptionInput): Promise<PackagingOption> {
  return request<PackagingOption>(
    '/packaging-options',
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    PackagingOptionSchema,
  );
}

export function patchPackagingOption(
  id: string,
  body: PatchPackagingOptionInput,
): Promise<PackagingOption> {
  return request<PackagingOption>(
    `/packaging-options/${encodeURIComponent(id)}`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    PackagingOptionSchema,
  );
}

export function archivePackagingOption(id: string): Promise<PackagingOption> {
  return request<PackagingOption>(
    `/packaging-options/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
    {},
    PackagingOptionSchema,
  );
}

export function activatePackagingOption(id: string): Promise<PackagingOption> {
  return request<PackagingOption>(
    `/packaging-options/${encodeURIComponent(id)}/activate`,
    { method: 'POST' },
    {},
    PackagingOptionSchema,
  );
}
